import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";
import {store} from "Store";

export const RECAPTCHA_VERIFY_URL = "/api/captcha/recaptcha-verify";

const verifyRecaptchaV3 = async (token, captchaAction, userId) => {
  let status = STATUSES.SUCCESS;
  const loginState = store.getState().loginInfo;

  const body = {
    token: token,
    captchaAction: captchaAction,
  };

  const res = await http
    .post(RECAPTCHA_VERIFY_URL, body, {
      headers: {
        "Authorization": "Bearer " + loginState?.token
      }
    })
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    })
    .catch(function (error) {
      status = STATUSES.ERROR;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

export { verifyRecaptchaV3 };
